const template = document.createElement('template');

template.innerHTML = `
  <style>
    .toast {
      position: fixed;
      top: 6rem;
      right: 2rem;
      max-width: 300px;
      padding: 1rem;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
      background-color: black;
      color: white;
    }
  </style>
  <div class="toast">
    <slot></slot>
  </div>
`;

class ToastNotification extends HTMLElement {
    get type() {
        return this.getAttribute('type');
    }

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    connectedCallback() {
        this.initRemove();
    }

    initRemove(time) {
        const seconds = (time) ? time : 3000;
        setTimeout(() => {
            document.getElementById('MainContent').removeChild(this);
        }, seconds);
    }
}

window.customElements.define('toast-notification', ToastNotification);
